import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className?: string;
  children?: React.ReactNode;
}

export const Pagination = styled.nav<IProps>`
  display: none;

  @media ${({ theme }) => theme.media.xl} {
    display: block;

    .pagination {
      ${mixin.flex({})};
      gap: 0 4px;

      .btn {
        width: 38px;
        height: 38px;
        color: #999;
        font-size: 15px;
        padding: 0 10px;
      }

      .active .btn {
        color: #fff;
        background: #333;
        border-radius: 50%;
        font-weight: 500;
      }

      .disabled {
        pointer-events: none;
        opacity: 0.4;
        display: none;
      }

      .btn-first,
      .btn-last,
      .btn-prev,
      .btn-next {
        .btn {
          width: 16px;
          height: 16px;
          padding: 0;
        }
      }

      .btn-first,
      .btn-prev {
        svg {
          transform: rotate(180deg);
        }
      }

      .btn-first {
        margin-right: 20px;
      }

      .btn-prev {
        margin-right: 24px;
      }

      .btn-last {
        margin-left: 20px;
      }

      .btn-next {
        margin-left: 24px;
      }
    }
  }
`;
